import React, { useRef } from "react";
import classnames from "classnames/bind";
import style from "./index.module.scss";
import {
  IComponentVolumes,
  IRecommendations,
  IState,
  Replacement,
  IServiceIntervals,
  ProductCategory,
} from "../../../interface";
import OilThumb from "../../OilThumb";
import OilBaseInfomation from "../../OilBaseInfomation";
import OilVolumesService from "../../OilVolumesService";
import Printable from '../../RecommendationPrintable/Product';
import localesReplacement from "../../../utils/localesReplacement";
import { useReactToPrint } from 'react-to-print';
import { connect } from "react-redux";
import {useSearchParams} from 'react-router-dom';
import { Dispatch } from "redux";
import actions from "../../../redux/actions";
import _ from 'lodash';
import { useAppName } from "../../../hooks/use-app-names";
import { APPNAME, FASTSCAN } from "../../../constants";

const cx = classnames.bind(style);

interface IProps {
  dataList: IRecommendations;
  replacements: Replacement;
  setVehicleComponentVolumes: (value: IComponentVolumes[]) => void;
  setServiceIntervals: (value: IServiceIntervals[]) => void;
  productCategories: ProductCategory[];
  vehicle?:any,
  notes?: string[];
}

export const CastrolRecommendation = (props: IProps) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const {
    dataList,
    replacements,
    setVehicleComponentVolumes,
    setServiceIntervals,
    productCategories,
    vehicle,
    notes
  } = props;
  const isFastScan = useAppName(FASTSCAN);
  const ref = useRef<HTMLDivElement>(null);
  const moreLinkClick = () => {
    setServiceIntervals(
      dataList.recommendedProduct.serviceIntervals
    );
    setVehicleComponentVolumes(dataList.vehicleComponentVolumes);
    searchParams.set('id', _.toString(dataList.recommendedProduct.id));
    searchParams.set('page', 'product');
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
  };

  const printOptions = {
    content: () => ref?.current,
    copyStyles: true,
  }
  
  const handlePrint = useReactToPrint(printOptions);
  
  const pdsDataLayer=()=>{
    window.dataLayer.push({
      'event' : 'safetyDataSheetClick',
      'pageType' : 'recommended oils',
      'recommendationType' : 'castrol recommendation', //need to work
      'buttonName' : 'safetyDataSheets',
      'oilName' : dataList["recommendedProduct"].name,
      'oilCategory' : `${dataList?.name} ${dataList?.code}`,
      'vehicleModel' : `${vehicle?.make} ${vehicle?.model}`,
      'countryCode' : localStorage.getItem('countryCode')
    });
  }
  const msdsDataLayer=()=>{
    window.dataLayer.push({
      'event' : 'dataSheetClick',
      'pageType' : 'recommended oils',
      'recommendationType' : 'castrol recommendation', //need to work
      'buttonName' : 'dataSheets',
      'oilName' : dataList["recommendedProduct"].name,
      'oilCategory' : `${dataList?.name} ${dataList?.code}`,
      'vehicleModel' : `${vehicle?.make} ${vehicle?.model}`,
      'countryCode' : localStorage.getItem('countryCode')
    });
  }

  return (
    <>
      <Printable
        ref={ref}
        vehicle={vehicle}
        componentName={dataList.name}
        volumes={dataList.vehicleComponentVolumes}
        notes={notes}
        data={dataList.recommendedProduct}
      />
      <div className={cx("section")}>
        <div className={cx("recommendation-container")}>
          <h3>{localesReplacement(replacements, "Castrol Recommendation")}</h3>
        </div>
        <div className={cx("container")}>
          <div className={cx("sider")}>
            <OilThumb
              onPrintClick={handlePrint}
              withoutMoreLink={true}
              dataList={dataList["recommendedProduct"]}
              products={dataList}
              moreLinkClick={moreLinkClick}
              vehicleP={vehicle}
              Recommendation="castrol recommendation"
              componentName={dataList.name}
            />
          </div>
          <div className={cx("content")}>
            <OilBaseInfomation
              withoutMoreLink={true}
              dataList={dataList["recommendedProduct"]}
              moreLinkClick={moreLinkClick}
              productCategories={productCategories}
              onPrintClick={handlePrint}
            />
            <OilVolumesService
              withoutMoreLink={false}
              dataList={dataList["recommendedProduct"]}
              notes={notes}
              componentVolumes={dataList["vehicleComponentVolumes"]}
              moreLinkClick={moreLinkClick}
            />
            <div className={style['links']}>
              {dataList.recommendedProduct?.msdsUrl && (
                <a
                  onClick={msdsDataLayer}
                  href={dataList.recommendedProduct.msdsUrl}
                  target='_blank'
                  rel='noreferrer'
                  className='secondary-button'
                  role='button'
                >
                  { localesReplacement(replacements, 'Material Safety Data Sheets')}
                </a>
              )}
              {dataList.recommendedProduct?.pdsUrl && (
                <a
                onClick={pdsDataLayer}
                  href={dataList.recommendedProduct.pdsUrl}
                  target='_blank'
                  rel='noreferrer'
                  className='secondary-button'
                  role='button'
                >
                  { localesReplacement(replacements, 'Data Sheets')}
                </a>
              )}
            </div>            
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state: IState) => ({
  replacements: state.replacements,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setServiceIntervals: (value: IServiceIntervals[]) =>
    dispatch(actions.setServiceIntervals(value)),
  setVehicleComponentVolumes: (value: IComponentVolumes[]) =>
    dispatch(actions.setVehicleComponentVolumes(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CastrolRecommendation);
